export const userTypes = ["teacher", "student", "guardian"] as const;
export type UserType = typeof userTypes[number];
